import { render, staticRenderFns } from "./component-cf612bc7.vue?vue&type=template&id=da580132&scoped=true&"
import script from "./component-cf612bc7.vue?vue&type=script&lang=js&"
export * from "./component-cf612bc7.vue?vue&type=script&lang=js&"
import style0 from "./component-cf612bc7.vue?vue&type=style&index=0&id=da580132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da580132",
  null
  
)

export default component.exports